<template>
  <van-popup v-model="modalVisible" class="popup-wrap">
    <div class="popup-box">
      <div class="popup-title">用户提现</div>
      <div class="padding-b-8">
        <div class="label-title">真实姓名：</div>
        <div>
          <input type="text" v-model="withdrawForm.realname" placeholder="请输入您的真实姓名">
        </div>
      </div>
      <div class="padding-b-8">
        <div class="label-title">支付宝账号：</div>
        <div>
          <input type="text" v-model="withdrawForm.alipay" placeholder="请输入您的支付宝账号">
        </div>
      </div>
      <div class="padding-b-8">
        <div class="label-title">提现金额：</div>
        <div>
          <input type="text" v-model="withdrawForm.money" placeholder="请输入您的提现金额">
        </div>
      </div>
      <div>最大可提现金额：<span class="color-ff8">{{info.max_withdraw_amount}}</span> 元</div>
      <div class="padding-t-30 btn-wrap">
        <div class="cancel-btn" @click="cancelWithdraw()">取消</div>
        <div class="sure-btn" @click="submitWithdraw()">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import { alipayWithdraw } from '@/api/withdraw'
  export default {
    name: "Add",
    data: function () {
      return {
        modalVisible: false,
        withdrawForm: {
          realname: '',
          alipay: '',
          money: ''
        },
        loading:false
      }
    },
    props: {
      info: {
        type: Object,
        default: {}
      },
    },
    mounted: function () {
      this.modalVisible = false
    },
    methods: {
      init: function () {
        this.modalVisible = true
      },
      cancelWithdraw() {
        this.modalVisible = false;
      },
      submitWithdraw: function () {
        if(this.loading){
          return
        }
        if(!this.withdrawForm.realname){
          this.$toast.fail('请填写真实姓名')
          return
        }
        if(!this.withdrawForm.alipay){
          this.$toast.fail('请填写支付宝账号')
          return
        }
        if(!this.withdrawForm.money){
          this.$toast.fail('请填写提现金额')
          return
        }
        this.loading = true;
        alipayWithdraw(this.withdrawForm).then(response => {
          this.modalVisible = false
          this.loading = false
          this.$toast.success(response.message)
        }).catch(error => {
          this.modalVisible = false
          this.loading = false
          console.log(error)
        })
      },
      cancelSubmit: function () {
        this.modalVisible = false
      }
    },
  }
</script>

<style lang="less" scoped>
  .popup-wrap{
    width: calc(100% - 60px);
    max-height: calc(100% - 118px);
    border-radius: 8px;
    .popup-box{
      height: auto;
      padding: 20px;
      .popup-title{
        font-family: Alibaba-PuHuiTi-M;
        font-size: 18px;
        color: #222222;
        text-align: center;
        padding: 5px 0 25px 0;
      }
      .label-title{
        font-size: 14px;
        color: #666666;
        padding-bottom: 8px;
      }
      input{
        width: 100%;
        letter-spacing: 0;
        font-size: 14px;
        border-radius: 2px;
        background: #FAFAFA;
        height: 44px;
        padding: 0 12px;
      }
      .btn-wrap{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        line-height: 35px;
        text-align: center;
        font-size: 16px;
        .reset-btn,.copy-btn{
          width: 130px;
          height: 35px;
          border-radius: 20px;
          color: #222222;
          border: 1px solid #EEEEEE;
        }
        .cancel-btn{
          width: 130px;
          height: 35px;
          background: #EEEEEE;
          border-radius: 20px;
          color: #666666;
        }
        .sure-btn{
          width: 130px;
          height: 35px;
          background: #FF8622;
          border-radius: 20px;
          color: #FFFFFF;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/account/modal/Withdraw.vue